import {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useState,
} from 'react';

import SigmaDeviceManager from '@socure-inc/device-risk-sdk';
import PropTypes from 'prop-types';

const Context = createContext({
  sessionToken: null,
  initializeSession: () => {},
});

export const SocureSessionContext = ({ children }) => {
  const [sessionToken, setSessionToken] = useState(null);

  useEffect(() => {
    const sdkKey = window.Chime?.config?.SOCURE_PUBLIC_KEY;
    const configBaseUrl = window.Chime?.config?.SOCURE_CONFIG_BASE_URL;

    if (sdkKey) {
      SigmaDeviceManager.initialize({ sdkKey, configBaseUrl });
    } else {
      // eslint-disable-next-line no-console
      console.warn(
        'Socure SDK initialization skipped: Missing SOCURE_PUBLIC_KEY'
      );
    }
  }, []);

  const initializeSession = useCallback(async () => {
    try {
      if (!window.Chime?.config?.SOCURE_PUBLIC_KEY) {
        return;
      }
      const token = await SigmaDeviceManager.getSessionToken();
      setSessionToken(token);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Failed to collect Socure session token:', error);
    }
  }, []);

  return (
    <Context.Provider
      value={{
        sessionToken,
        initializeSession,
      }}
    >
      {children}
    </Context.Provider>
  );
};

SocureSessionContext.propTypes = {
  children: PropTypes.node.isRequired,
};

export const useSocureSession = () => {
  const { sessionToken } = useContext(Context);
  return sessionToken;
};

export const useInitializeSocureSession = () => {
  const { initializeSession } = useContext(Context);

  useEffect(() => {
    initializeSession();
  }, [initializeSession]);
};
